import banner from '../../../assets/industries/banner.webp'

import tick from '../../../assets/industries/tick.webp'

import design from '../../../assets/industries/design.svg'
import website from '../../../assets/industries/website.svg'
import woo from '../../../assets/industries/woo.svg'
import custom from '../../../assets/industries/custom.svg'
import megneto from '../../../assets/industries/megneto.svg'
import shopify from '../../../assets/industries/shopify.svg'


export const bannerData = {
    title1: 'Ecommerce Website',
    title2: 'Development Services',
    desc: 'Partner with an experienced eCommerce website development company to scale your online store.',
    img: banner,
    btnTitle: 'Hire Ecommerce Developers'
}

export const hireData = {
    img: tick,
    title: 'Hire Ecommerce Website',
    points: [
        'Transparent pricing',
        'Hands-on experience in software development for eCommerce industry',
        'Streamlined communications and comprehensive reporting',
        'Data privacy protection',
        'Individual approach to every client',
        'Deep understanding of eCommerce development technologies',
        'Flexible engagement models',

    ]
}

export const webDesignData = {
    title1: 'Offering a Range of',
    title1Span: 'eCommerce Website Design',
    title2: 'and Development Services',
    cards: [
        {
            title: 'Custom eCommerce Design',
            desc: 'Creating a brand association makes consumers aware of brand quality and custom designs are a great way of reflecting your business values and brand. We create irresistible custom eCommerce web designs to level up your branding',
            img: custom
        },
        {
            title: 'Custom eCommerce Platforms',
            desc: 'With experience in custom eCommerce website development, our web developers build engaging eCommerce platforms that drive online sales. We focus on designing and developing eCommerce web solutions tailored to your needs.',
            img: design
        },
        {
            title: 'Magento Development',
            desc: 'Our developers know how to combine technology and creativity to build b2b and b2c Magento eCommerce solutions that grow your business and reduce costs.',
            img: megneto
        },
        {
            title: 'WooCommerce Development',
            desc: 'We are well aware of the power of WooCommerce development platforms and provide dedicated teams. So you can hire Woocommerce developers to boost online sales.',
            img: woo
        },
        {
            title: 'Shopify Development',
            desc: 'Shopify is suitable for entry-level B2C (Business to Customers) Ecommerce web development. Codezone offers Shopify development solutions focusing on ease of use to minimize development time and cost.',
            img: shopify
        },
        {
            title: 'Ecommerce Website Solutions',
            desc: 'If you need a custom eCommerce website and are worried about steep ecommerce website development prices, hiring Codezone eCommerce developers is your best bet. With top eCommerce web development services, we develop an inspiring eCommerce web solution.',
            img: website
        },
    ]
}